import React from "react";

export const PROFIT_PORTAL_TOKEN_KEY = "profit_portal_token";
export const PROFIT_PORTAL_SESSION_KEY = "profit_portal_session";

const ProfitAuthStateContext = React.createContext();
const ProfitAuthActionsContext = React.createContext();

function ProfitAuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = React.useState(
    Boolean(localStorage.getItem(PROFIT_PORTAL_TOKEN_KEY)),
  );

  React.useEffect(() => {
    function handleStorage(event) {
      if (event.key === PROFIT_PORTAL_TOKEN_KEY) {
        setIsAuthenticated(Boolean(event.newValue));
      }
    }

    window.addEventListener("storage", handleStorage);

    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  const actions = React.useMemo(
    () => ({
      login(session) {
        localStorage.setItem(PROFIT_PORTAL_TOKEN_KEY, "static-profit-session");
        localStorage.setItem(
          PROFIT_PORTAL_SESSION_KEY,
          JSON.stringify({
            ...(session || {}),
            source: "static",
            createdAt: new Date().toISOString(),
          }),
        );
        setIsAuthenticated(true);
      },
      logout() {
        localStorage.removeItem(PROFIT_PORTAL_TOKEN_KEY);
        localStorage.removeItem(PROFIT_PORTAL_SESSION_KEY);
        setIsAuthenticated(false);
      },
    }),
    [],
  );

  return (
    <ProfitAuthStateContext.Provider value={isAuthenticated}>
      <ProfitAuthActionsContext.Provider value={actions}>
        {children}
      </ProfitAuthActionsContext.Provider>
    </ProfitAuthStateContext.Provider>
  );
}

function useProfitAuthState() {
  const context = React.useContext(ProfitAuthStateContext);

  if (context === undefined) {
    throw new Error("useProfitAuthState must be used within ProfitAuthProvider");
  }

  return context;
}

function useProfitAuthActions() {
  const context = React.useContext(ProfitAuthActionsContext);

  if (context === undefined) {
    throw new Error("useProfitAuthActions must be used within ProfitAuthProvider");
  }

  return context;
}

export { ProfitAuthProvider, useProfitAuthActions, useProfitAuthState };
